import { useMemo, useState } from "react";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import SongsPresenter from "./SongsPresenter";
import _, { sumBy } from 'lodash';
import { TopSongsPeriod } from "./models";
import { useTopSongs } from "../../api/streaming";
import { useArtistFilter } from "@arelia-hooks/artistAccount";

export default function SongsContainer() {
  const requiredConnectionNames = [ConnectionName.spotify, ConnectionName.amazon, ConnectionName.appleMusic, ConnectionName.pandora];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);
  const [selectedPeriod, setSelectedPeriod] = useState(TopSongsPeriod.AllTime);
  const { data, isLoading, isError } = useTopSongs(selectedPeriod, { enabled: hasRequiredConnections });
  const filteredData = useArtistFilter(data);

  const [songs, services] = useMemo(() => {
    if (!data) return [[], []];
    const services = _(filteredData).map(x => x.networkName).uniq().orderBy(x => x, "asc").value();

    const songsArray = _(filteredData)
      .flatMap(x => x.songs.map(y => ({ ...y, networkName: x.networkName })))
      .groupBy(x => x.name)
      .entries().map(([name, vals]) => ({
        name,
        quantity: sumBy(vals, x => x.quantity),
        byService: _(vals).keyBy(x => x.networkName).mapValues(x => x.quantity).value()
      }))
      .orderBy(x => x.quantity, "desc")
      .take(8).value();

    return [songsArray, services];
  }, [filteredData]);

  return <SongsPresenter
    songs={songs}
    services={services}
    loading={isLoading}
    error={isError}
    unconnected={!hasRequiredConnections}
    selectedPeriod={selectedPeriod}
    handlePeriodChange={setSelectedPeriod}
  />;
}
